/*  JSON-LD builders — never fabricate ratings, reviews, prices or facts. Only
    emit fields that come straight out of our CMS (name, slug, country, iata…).
    Used by SEOHead across public pages (Home, About, Destinations, Airports,
    Airlines) to improve crawlability without inviting a manual-action.         */
import { SITE } from "./site";

const CTX = "https://schema.org";
const base = (p) => `${SITE.url}${p.startsWith("/") ? p : `/${p}`}`;

export const websiteLd = () => ({
  "@context": CTX, "@type": "WebSite",
  name: SITE.name, url: SITE.url,
  potentialAction: {
    "@type": "SearchAction",
    target: { "@type": "EntryPoint", urlTemplate: `${SITE.url}/search?q={query}` },
    "query-input": "required name=query",
  },
});

export const organizationLd = () => ({
  "@context": CTX, "@type": "Organization",
  name: SITE.name, url: SITE.url,
  logo: `${SITE.url}/android-chrome-512x512.png`,
  sameAs: [
    "https://socialpulse.com",
    "https://airlinesairports.com",
    "https://indianairports.com",
    "https://hotelspulse.pro",
    "https://keralatravels.com",
  ],
});

/** Breadcrumb from an array of [name, path]. Omit path on the terminal crumb. */
export const breadcrumbLd = (items) => ({
  "@context": CTX, "@type": "BreadcrumbList",
  itemListElement: items.filter(Boolean).map(([name, path], i) => ({
    "@type": "ListItem", position: i + 1, name,
    item: path ? base(path) : undefined,
  })),
});

export const touristDestinationLd = (d) => {
  if (!d?.name) return null;
  return {
    "@context": CTX, "@type": "TouristDestination",
    name: d.name,
    url: base(d.slug ? `/destinations/${d.slug}` : `/destinations/${d.id}`),
    description: d.summary || d.description,
    image: d.cover || d.photo || undefined,
    containedInPlace: d.country ? { "@type": "Country", name: d.country } : undefined,
    geo: (d.lat != null && d.lon != null) ? {
      "@type": "GeoCoordinates", latitude: d.lat, longitude: d.lon,
    } : undefined,
  };
};

export const airportLd = (a) => {
  if (!a?.iata && !a?.name) return null;
  return {
    "@context": CTX, "@type": "Airport",
    name: a.name || `${a.iata} Airport`,
    iataCode: a.iata || undefined,
    icaoCode: a.icao || undefined,
    url: base(`/airports/${a.iata || a.id}`),
    address: a.city || a.country ? {
      "@type": "PostalAddress",
      addressLocality: a.city || undefined,
      addressCountry: a.country || undefined,
    } : undefined,
    geo: (a.lat != null && a.lon != null) ? {
      "@type": "GeoCoordinates", latitude: a.lat, longitude: a.lon,
    } : undefined,
  };
};

export const airlineLd = (a) => {
  if (!a?.iata && !a?.name) return null;
  return {
    "@context": CTX, "@type": "Airline",
    name: a.name || `${a.iata} Airlines`,
    iataCode: a.iata || undefined,
    url: base(`/airlines/${a.iata || a.id}`),
    logo: a.logo || undefined,
    foundingDate: a.founded_year ? String(a.founded_year) : undefined,
    legalName: a.legal_name || undefined,
  };
};

/** Collapse undefined fields (schema validators dislike them). */
export const cleanLd = (obj) => JSON.parse(JSON.stringify(obj));
